import { render, staticRenderFns } from "./Tcplayer.vue?vue&type=template&id=4bf9c9a1&scoped=true"
import script from "./Tcplayer.vue?vue&type=script&lang=js"
export * from "./Tcplayer.vue?vue&type=script&lang=js"
import style0 from "./Tcplayer.vue?vue&type=style&index=0&id=4bf9c9a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9c9a1",
  null
  
)

export default component.exports